import { Box, BoxProps, styled } from '@mui/material';

import { getAspectRatioStr, PromoImageType } from '@models/Image';

export type AspectRatioProps = BoxProps & {
  ratio: PromoImageType;
};

export const AspectRatio = styled(Box)<AspectRatioProps>`
  align-items: center;
  box-sizing: border-box;
  aspect-ratio: ${({ ratio }) => getAspectRatioStr(ratio)};
  display: flex;
  position: relative;
  justify-content: center;
  object-fit: cover;
  overflow: hidden;
`;
